export const isEmbedded = () => window.top !== window.self;
